export const customs = [
  {
    title: "Mangokkal Holi",
    description: "Upacara pemindahan tulang leluhur ke tugu peringatan (simin), ritual sakral sebagai penghormatan dan identitas marga.",
    process:
      "Tulang-belulang leluhur digali dari makam, dibersihkan, kemudian dipindahkan ke tugu batu (simin) keluarga.",
    significance:
      "Memperkuat hubungan dengan leluhur dan menjaga identitas budaya Batak Toba.",
    participants: "Seluruh keluarga besar marga, tokoh adat, dan jemaat gereja.",
    image: "https://img.jakpost.net/c/2016/05/15/2016_05_15_4590_1463306617._large.jpg", // ilustrasi: gali & pemindahan tulang
    references: [
      {
        title: "Mangongkal Holi – Wikipedia",
        url: "https://id.wikipedia.org/wiki/Mangongkal_holi",
      },
      {
        title: "The “Mangokal Holi” Tradition of the Batak Toba Tribe – The Jakarta Post",
        url: "https://www.thejakartapost.com/multimedia/2016/05/15/the-mangokal-holi-tradition-of-the-batak-toba-tribe.html",
      },
    ],
  },
  {
    title: "Horja Bius",
    description: "Upacara adat Batak Toba yang berfungsi menyatukan marga, biasanya dalam rangka pernikahan atau forum adat.",
    process:
      "Serangkaian ritual yang melibatkan seluruh keluarga dan diisi dengan pemberian ulos, makanan, serta doa bersama.",
    significance:
      "Menjaga harmoni antar-marga dan menyatukan keluarga dalam tradisi serta doa.",
    participants: "Keluarga pengantin, tokoh adat, masyarakat marga.",
    image: "https://upload.wikimedia.org/wikipedia/commons/thumb/7/7f/Batak_Toba_-_Horja_Bius.svg/768px-Batak_Toba_-_Horja_Bius.svg.png",
    references: [
      {
        title: "Horja Bius – Wikipedia",
        url: "https://id.wikipedia.org/wiki/Horja_Bius",
      },
      {
        title: "Acara Horja Bius di Tarutung – Foto Editorial",
        url: "https://www.shutterstock.com/image-photo/tarutung-indonesia-july-12th-2022-horja-2339989415",
      },
    ],
  },
  {
    title: "Sipaha Lima",
    description: "Upacara tahunan agama Parmalim bagi Batak Toba yang diselenggarakan selama tiga hari secara sakral.",
    process:
      "Meliputi tiga fase: pembukaan (parsahadatan), puncak persembahan (pameleon bolon), dan penutup (panantion).",
    significance:
      "Pengabdian kepada Tuhan (Debata Mulajadi Nabolon) dan pelestarian kepercayaan Parmalim.",
    participants: "Penganut Parmalim dan komunitas adat Batak Toba.",
    image: "https://awsimages.detik.net.id/community/media/visual/2023/11/30/ritual-sipaha-lima-foto-dok-kemendikbud_169.jpeg",
    references: [
      {
        title: "Sipaha Lima – Indonesia.go.id",
        url: "https://indonesia.go.id/ragam/budaya/kebudayaan/sipaha-lima-tradisi-leluhur-batak-mensyukuri-hasil-panen",
      },
      {
        title: "Sipaha Lima – Editorial Stock Photo",
        url: "https://www.shutterstock.com/editorial/image-editorial/bataknese-people-during-sipaha-lima-ceremony-local-8907159d",
      },
    ],
  },
];
